import React from "react";
import { useLocalization } from "../../context/LocalizationContext";
import { useEndSession } from "../../hooks/useEndSession";
import EndSessionConfirmModal from "../../components/shared/EndSessionConfirmModal";
import "./styles.css";
import endSessionIcon from "../../assets/icons/newDesign/endSession.svg";
import CircularButton from "../../components/shared/CircularButton";
import Header from "../../containers/Header";

const EndSession: React.FC = () => {
  const { t } = useLocalization();
  const { showConfirm, isEnding, requestEndSession, confirmEndSession, cancelEndSession } = useEndSession();

  return (
    <div className="end-session page-container">
      <Header
        showHomeButton
        showSettingsButton
      />
      <div className="end-content">
        <h1 className="end-title page-title">{t("endSession.title")}</h1>
        <p className="end-subtitle page-subtitle">{t("endSession.description")}</p>
        <CircularButton
          variant="danger"
          icon={endSessionIcon}
          label={''}
          onClick={requestEndSession}
          disabled={isEnding}
        />
      </div>
      <EndSessionConfirmModal
        isOpen={showConfirm}
        onClose={cancelEndSession}
        onConfirm={confirmEndSession}
        isEnding={isEnding}
      />
    </div>
  );
};

export default EndSession;
